var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdhd4Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e2a759;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #dabe8c;\n      }\n\n      .cls-7 {\n        font-size: 18px;\n      }\n\n      .cls-7, .cls-8 {\n        fill: #184655;\n        font-family: Arial-BoldMT, Arial;\n        font-weight: 700;\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: #dba84f;\n      }\n\n      .cls-4 {\n        fill: #ddb472;\n      }\n\n      .cls-5 {\n        fill: #e2b272;\n      }\n\n      .cls-9 {\n        letter-spacing: -.0743em;\n      }\n\n      .cls-8 {\n        font-size: 5.45px;\n      }\n\n      .cls-6 {\n        fill: #e4bf8b;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 37.5,
    cy: 37.5,
    r: 37.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 12.5,
    y: 9.6,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.5,
    y: 1.6,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.5,
    y: 17.6,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.5,
    y: 26.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.5,
    y: 9.6,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(11.6513 37.4999)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ADHD")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(11.6511 50.4464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 3.936,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.4673,
    y: 0
  }, "TING SCALE - IV")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhd4Icon);
export default __webpack_public_path__ + "static/media/adhd4-icon.cd7428fb063395c08a6f486a8b236e61.svg";
export { ForwardRef as ReactComponent };